import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      background: palette.background.box,
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.boxShadow,
      fontFamily: 'montserrat',
      fontWeight: 600,
      color: palette.text.secondary,
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflow: 'hidden',
      zIndex: 0,
      padding: '20px',
      height: '100%',
      gap: '20px'
    },
    title: {
      color: palette.common.black,
      margin: 0,
      fontSize: '1.5rem'
    },
    infosContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '30px',
      backgroundColor: palette.background.underBox,
      borderRadius: palette.borderRadius.default,
      padding: '10px'
    },
    textIconContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
      gap: '5px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
